import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Tooltip, OverlayTrigger, Badge, Modal, Table, Button } from "react-bootstrap";
import documents from '../../../../images/doc.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import raw from '../../../../images/raw_material/else.jpg';

const ViewPurchase = () => {

    const location = useLocation(); 
    const queryParams = new URLSearchParams(location.search);
    const sno = queryParams.get('data');

    const [hovered, setHovered] = useState(false);
    const [purchase, setPurchase] = useState(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const containerStyle = {
        position: 'relative',
        width: '100px',
        height: '110px',
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        transform: hovered ? 'scale(1.05)' : 'scale(1)',
        boxShadow: hovered ? '0 6px 16px rgba(0, 0, 0, 0.25)' : 'none',
    };

    const iconStyle = {
        display: hovered ? 'inline-block' : 'none',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgb(180, 228, 126)',
        borderRadius: '50%',
        padding: '8px',
        transition: 'opacity 0.3s ease',
    };

    const onInit = () => { };

    useEffect(() => {
        if (sno) {
            fetch(`${baseURL}/purchases/${sno}`)
                .then(res => res.json())
                .then(data => {
                    if (data.data) {
                        setPurchase(data.data);
                    } else {
                        setPurchase(null);
                    }
                })
                .catch(err => {
                    console.error("Failed to fetch purchase:", err);
                    setPurchase(null);
                });
        }
    }, [sno, baseURL]);


    /*  
     ============================================================
     ✔ FIXED: Pending Purchase Mapping
     ============================================================
    */

    const pendingPurchase =
        purchase?.pending_purchase?.flatMap(block =>
            block.purchased_list.map(item => ({
                ...item,
                pending_reason: block.pending_reason,
                purchased_date: block.purchased_date
            }))
        ) || [];

    const getMaterialDetails = (id) => {
        const rm = purchase.raw_material.find(r => r.raw_material_id === id);

        if (!rm) return { name: "-", unit: "-" };

        return {
            name: rm.rawmaterial_name,
            unit: rm.unitslug_name
        };
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <h4 className='breadcrumb-header'>View Purchase</h4>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item">/</li>
                        <li className="breadcrumb-item">Purchase Management</li>
                        <li className="breadcrumb-item">/</li>
                        <li className="breadcrumb-item active"><Link to='/manage-purchase'>Manage Purchase</Link></li>
                    </ol>
                </div>
            </div>

            {purchase && (
                <div className="row mb-4">

                    {/* LEFT DETAILS */}
                    <div className="col-lg-3 col-md-4 col-sm-2 mb-2 px-4 py-4 rounded mx-4" style={{ border: '1px solid #bebebeff' }}>
                        <div className='row'>
                            {/* <div className='col-lg-12 mb-3'>
                                <label className='text-black font-w600 fs-7'>Purchase Date</label>
                                <div className='text-success fs-6'>{purchase.purchase_date}</div>
                            </div> */}
                            <div className='col-lg-12 mb-3'>
                                <label className='text-black font-w600 fs-7'>Purchase Date</label>
                                <div className='text-success fs-6'>
                                    {purchase.purchase_date
                                        ? new Date(purchase.purchase_date).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                        })
                                        : '-'}
                                </div>
                            </div>


                            <div className='col-lg-12 mb-3'>
                                <label className='text-black font-w600 fs-7'>Purchase ID</label>
                                <div className='text-success fs-6'>{purchase.purchase_id}</div>
                            </div>

                            <div className='col-lg-12 mb-3'>
                                <label className='text-black font-w600 fs-7'>Raw Material Count</label>
                                <Badge bg="primary" className='text-white fs-6 px-3 py-0'>
                                    {purchase.no_of_rawmaterial}
                                </Badge>
                            </div>

                            <div className='col-lg-12 mb-3'>
                                <label className='text-black font-w600 fs-7'>Vendor</label>
                                <div className='text-success fs-6'>{purchase.vendor_businessname}</div>
                            </div>

                            <div className='col-lg-12 mb-3'>
                                <label className='text-black font-w600 fs-7'>Assign Staff</label>
                                <div className='text-success fs-6'>{purchase.purchase_staffname}</div>
                            </div>

                            {/* BILL LIST */}
                            <div className='col-lg-12 mb-3'>
                                <label className='text-black font-w600 fs-7'>Bill</label>

                                <div className="avatar-upload d-flex flex-column align-items-start">
                                    <div className="change position-relative">
                                        <div
                                            className="d-flex flex-wrap gap-2 px-2 py-2"
                                            style={{
                                                maxHeight: purchase?.bill?.length > 2 ? '220px' : 'auto',
                                                overflowY: purchase?.bill?.length > 2 ? 'auto' : 'visible',
                                            }}
                                        >
                                            {purchase.bill && purchase.bill.length > 0 ? (
                                                purchase.bill.map((file, idx) => {
                                                    const fileUrl = `${baseURL.replace(/\/api$/, '')}/${file.file_name}`;
                                                    const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(file.file_name);

                                                    return (
                                                        <div
                                                            key={idx}
                                                            style={containerStyle}
                                                            onMouseEnter={() => setHovered(true)}
                                                            onMouseLeave={() => setHovered(false)}
                                                        >
                                                            <img
                                                                src={isImage ? fileUrl : documents}
                                                                style={imageStyle}
                                                            />

                                                            {/* View */}
                                                            <a href={fileUrl} target="_blank" rel="noreferrer" style={iconStyle}>
                                                                <i className="fa-solid fa-eye text-black fs-6"></i>
                                                            </a>

                                                            {/* Download */}
                                                            <a
                                                                href={fileUrl}
                                                                download
                                                                style={{ ...iconStyle, top: '70%', backgroundColor: '#dfe6e9' }}
                                                            >
                                                                <i className="fa-solid fa-download text-black fs-6"></i>
                                                            </a>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div>No Bill Uploaded</div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
 
                    {/* <div className='col-lg-8 mb-3'>
                        <div className='row'>
                            <div className='col-lg-12 d-flex align-items-center gap-2 mb-2'>
                                <label className='text-red font-w600 fs-4'>Purchase Items</label>

                                {purchase.purchase_status === 1 && (
                                    <>
                                        <Badge bg="warning" className="text-black fs-7">Verification Pending</Badge>
                                        <OverlayTrigger overlay={<Tooltip>Raw Material shortage</Tooltip>}>
                                            <i className="fa-solid fa-circle-question fs-6 ms-1 text-black"></i>
                                        </OverlayTrigger>
                                    </>
                                )}

                                {purchase.purchase_status === 0 && (
                                    <Badge bg="primary" className="text-white fs-7">Generated</Badge>
                                )}

                                {purchase.purchase_status === 2 && (
                                    <Badge bg="danger" className="text-white fs-7">Verified</Badge>
                                )}
                            </div>
 
                            <div className='col-lg-12'>
                                <div className='row scroll-y mh-450px'>
                                    {purchase.raw_material.map((rm, index) => (
                                        <div
                                            key={rm.raw_material_id || index}
                                            className='col-lg-12 mb-3 position-relative'
                                            style={{
                                                backgroundColor: rm.is_pending ? 'rgba(220, 53, 69, 0.1)' : '',
                                                borderRadius: '4px',
                                                padding: '2px'
                                            }}
                                        >

                                            {rm.is_pending && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    left: '0px',
                                                    width: '50px',
                                                    height: '28px',
                                                    background: '#dc3545',
                                                    color: '#fff',
                                                    fontSize: '11px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transform: 'rotate(-30deg)',
                                                    zIndex: 10
                                                }}>
                                                    Pending
                                                </div>
                                            )}

                                            <div className='d-flex align-items-center justify-content-between gap-2 border rounded px-1 py-1'>
                                                <div className="d-flex align-items-center gap-3">
                                                    <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                        <div data-src={rm.image_url || raw} className='rounded'>
                                                            <img
                                                                src={rm.image_url || raw}
                                                                className='cursor-pointer w-60px h-60px'
                                                                style={{ objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                    </LightGallery>

                                                    <div className="d-flex flex-column text-truncate">
                                                        <label className='text-primary w-150px text-truncate'>
                                                            {rm.rawmaterial_name}
                                                        </label>

                                                        <label className='text-black fs-7'>
                                                            {rm.brand || '-'} / {rm.quantity} {rm.unitslug_name}
                                                        </label>

                                                        <label className='text-danger fs-7'>
                                                            ₹ {parseFloat(rm.total_cost || 0).toFixed(2)}
                                                        </label>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className='text-primary'>Received Quantity</label>
                                                    <div>
                                                        <span className='text-black fs-7 px-2 rounded' style={{ background: '#83e9a2' }}>
                                                            {rm.actual_quantity} {rm.unitslug_name}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className='text-primary'>Actual Amount</label>
                                                    <div>
                                                        <span className='text-black fs-7 px-2 rounded' style={{ background: '#70ccff' }}>
                                                            ₹ {parseFloat(rm.actual_price || 0).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
 
                    <div className='col-lg-11 mx-4 mt-4 px-4 rounded py-4' style={{ background: '#fff' }}>
                        <h4 className='text-black font-w600 mb-3'>Pending Purchase</h4>

                        <table className='table table-bordered align-middle'>
                            <thead className='bg-light'>
                                <tr>
                                    <th>S.No</th>
                                    <th>Raw Material</th>
                                    <th>Pending Qty</th>
                                    <th>Unit</th>
                                    <th>Reason</th>
                                    <th>Purchase Date</th>
                                </tr>
                            </thead>

                            <tbody>
                                {pendingPurchase.length > 0 ? (
                                    pendingPurchase.map((item, index) => {
                                        const rm = getMaterialDetails(item.raw_material_id);

                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{rm.name}</td>
                                                <td>{item.pending_quantity}</td>
                                                <td>{rm.unit}</td>
                                                <td>{item.pending_reason || '-'}</td>
                                                <td>{item.purchased_date}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={6} className="text-center text-muted">
                                            No pending purchase found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div> */}

                    {/* RAW MATERIAL LIST + PENDING PURCHASE COMBINED WRAPPER */}
                    <div className='col-lg-8 mb-3'>

                        {/* ====================== TITLE + STATUS ====================== */}
                        <div className='row'>
                            <div className='col-lg-12 d-flex align-items-center gap-2 mb-2'>
                                <label className='text-red font-w600 fs-4'>Purchase Items</label>

                                {purchase.purchase_status === 1 && (
                                    <>
                                        <Badge bg="warning" className="text-black fs-7">Verification Pending</Badge>
                                        <OverlayTrigger overlay={<Tooltip>Raw Material shortage</Tooltip>}>
                                            <i className="fa-solid fa-circle-question fs-6 ms-1 text-black"></i>
                                        </OverlayTrigger>
                                    </>
                                )}

                                {purchase.purchase_status === 0 && (
                                    <Badge bg="primary" className="text-white fs-7">Generated</Badge>
                                )}

                                {purchase.purchase_status === 2 && (
                                    <Badge bg="danger" className="text-white fs-7">Verified</Badge>
                                )}
                            </div>

                            {/* ====================== RAW MATERIAL CARDS ====================== */}
                            {/* <div className='col-lg-12'>
                                <div className='row scroll-y mh-450px'>
                                    {purchase.raw_material.map((rm, index) => (
                                        <div
                                            key={rm.raw_material_id || index}
                                            className='col-lg-12 mb-3 position-relative'
                                            style={{
                                                backgroundColor: rm.is_pending ? 'rgba(220,53,69,0.1)' : 'transparent',
                                                borderRadius: '4px',
                                                padding: '2px'
                                            }}
                                        >
 
                                            {rm.is_pending && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    left: '0px',
                                                    width: '50px',
                                                    height: '28px',
                                                    background: '#dc3545',
                                                    color: '#fff',
                                                    fontSize: '11px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transform: 'rotate(-30deg)',
                                                    zIndex: 10
                                                }}>
                                                    Pending
                                                </div>
                                            )}

                                            <div className='d-flex align-items-center justify-content-between gap-2 border rounded px-1 py-1'>
                                                <div className="d-flex align-items-center gap-3">

                                                    <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                        <div data-src={rm.image_url || raw} className='rounded'>
                                                            <img
                                                                src={rm.image_url || raw}
                                                                className='cursor-pointer w-60px h-60px'
                                                                style={{ objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                    </LightGallery>

                                                    <div className="d-flex flex-column text-truncate">
                                                        <label className='text-primary w-150px text-truncate'>
                                                            {rm.rawmaterial_name}
                                                        </label>

                                                        <label className='text-black fs-7'>
                                                            {rm.brand || '-'} / {rm.quantity} {rm.unitslug_name}
                                                        </label>

                                                        <label className='text-danger fs-7'>
                                                            ₹ {parseFloat(rm.total_cost || 0).toFixed(2)}
                                                        </label>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className='text-primary'>Received Quantity</label>
                                                    <div>
                                                        <span className='text-black fs-7 px-2 rounded' style={{ background: '#83e9a2' }}>
                                                            {rm.actual_quantity} {rm.unitslug_name}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className='text-primary'>Actual Amount</label>
                                                    <div>
                                                        <span className='text-black fs-7 px-2 rounded' style={{ background: '#70ccff' }}>
                                                            ₹ {parseFloat(rm.actual_price || 0).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))}  
                                </div>
                            </div> */}
                            <div className='col-lg-12'>
                                <div className='row scroll-y mh-450px'>

                                    {/* -------------------------
                                        NORMAL RAW MATERIALS
                                    ------------------------- */}
                                    {purchase.raw_material.map((rm, index) => (
                                        <div
                                            key={rm.raw_material_id || index}
                                            className='col-lg-12 mb-3 position-relative'
                                            style={{
                                                backgroundColor: rm.is_pending ? 'rgba(220,53,69,0.1)' : 'transparent',
                                                borderRadius: '4px',
                                                padding: '2px'
                                            }}
                                        >
                                            {/* Pending Flag */}
                                            {rm.is_pending && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    left: '0px',
                                                    width: '50px',
                                                    height: '28px',
                                                    background: '#dc3545',
                                                    color: '#fff',
                                                    fontSize: '11px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transform: 'rotate(-30deg)',
                                                    zIndex: 10
                                                }}>
                                                    Pending
                                                </div>
                                            )}

                                            <div className='d-flex align-items-center justify-content-between gap-2 border rounded px-1 py-1'>
                                                <div className="d-flex align-items-center gap-3">
                                                    <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                        <div data-src={rm.image_url || raw} className='rounded'>
                                                            <img
                                                                src={rm.image_url || raw}
                                                                className='cursor-pointer w-60px h-60px'
                                                                style={{ objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                    </LightGallery>

                                                    <div className="d-flex flex-column text-truncate">
                                                        <label className='text-primary w-150px text-truncate'>
                                                            {rm.rawmaterial_name}
                                                        </label>

                                                        <label className='text-black fs-7'>
                                                            {rm.brand || '-'} / {rm.quantity} {rm.unitslug_name}
                                                        </label>

                                                        <label className='text-danger fs-7'>
                                                            ₹ {parseFloat(rm.total_cost || 0).toFixed(2)}
                                                        </label>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className='text-primary'>Received Quantity</label>
                                                    <div>
                                                        <span className='text-black fs-7 px-2 rounded' style={{ background: '#83e9a2' }}>
                                                            {rm.actual_quantity} {rm.unitslug_name}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className='text-primary'>Actual Amount</label>
                                                    <div>
                                                        <span className='text-black fs-7 px-2 rounded' style={{ background: '#70ccff' }}>
                                                            ₹ {parseFloat(rm.actual_price || 0).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {/* -------------------------
                                        AMOUNT PENDING ITEMS (status = 0)
                                    ------------------------- */}
                                    {purchase.pending_purchase?.flatMap(pp =>
                                        pp.purchased_list?.filter(item => item.amount_status === "0") || []
                                    ).map((rm, index) => (
                                        <div
                                            key={rm.raw_material_id || index}
                                            className='col-lg-12 mb-3 position-relative'
                                            style={{
                                                borderRadius: '4px',
                                                padding: '2px',
                                                backgroundColor: 'rgba(255,193,7,0.1)' // yellowish background for pending
                                            }}
                                        >
                                            <div className="d-flex align-items-center gap-3 px-2 py-1">
                                                <div className="d-flex flex-column text-truncate">
                                                    <label className='text-primary w-150px text-truncate'>
                                                        {rm.rawmaterial_name}
                                                    </label>

                                                    <label className='text-black fs-7'>
                                                        {rm.brand || '-'} / {rm.expected_quantity} {rm.unitslug_name}
                                                    </label>

                                                    <label className='text-danger fs-7'>
                                                        Pending Quantity: {rm.pending_quantity} {rm.unitslug_name}
                                                    </label>
                                                </div>

                                                <div className="ms-auto">
                                                    <div className="mt-2 px-3 py-2 rounded bg-warning text-dark fs-7 fw-bold">
                                                        Amount Pending
                                                        <div className="fs-7 mt-1">
                                                            Received: {rm.received_quantity} {rm.unitslug_name} <br />
                                                            Expected: {rm.expected_quantity} {rm.unitslug_name}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>



                        </div>

 

                    {/* ===========================
                        SHOW PENDING PURCHASE ONLY IF EXISTS
                    =========================== */}
                    {
                        purchase.pending_purchase &&
                        purchase.pending_purchase.length > 0 &&
                        purchase.pending_purchase.some(pp =>
                            pp.purchased_list?.some(item => item.amount_status === "1")
                        ) && (
                        
                            <div className='col-lg-12' style={{ background: '#fff' }}>
                                <h4 className='text-black font-w600 mb-3 '>Pending Purchase</h4>

                                <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-50px'>Raw Material</th>
                                            <th className='min-w-50px'>Purchase Date</th>
                                            <th className='min-w-50px'>Pending Qty</th>
                                            <th className='min-w-100px'>Reason</th>
                                        </tr>
                                    </thead>

                                    <tbody className="text-black-600 fw-semibold fs-7">
                                        {purchase.pending_purchase.flatMap(pp =>
                                            pp.purchased_list
                                                ?.filter(item => item.amount_status === "1") // ← Only show valid ones
                                                .map((item, index) => {

                                                    const rm = getMaterialDetails(item.raw_material_id);

                                                    return (
                                                        <tr key={`${pp.purchased_id}-${index}`}>
                                                            <td className='text-black'>{item.rawmaterial_name}</td>
                                                           <td className='text-black'>
                                                            {pp.purchased_date
                                                                ? new Date(pp.purchased_date).toLocaleDateString('en-GB', {
                                                                    day: '2-digit',
                                                                    month: 'short',
                                                                    year: 'numeric',
                                                                })
                                                                : '-'}
                                                            </td>

                                                            <td className='text-black'>{item.pending_quantity} {item.unitslug_name}</td>
                                                            <td className='text-black'>{pp.pending_reason || '-'}</td>
                                                        </tr>
                                                    );
                                                })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )
                    }


 
 
                    </div>



                    {/* SUMMARY */}
                    <div className='col-lg-11 mb-2 mt-4 px-4 mx-4 d-flex align-items-center justify-content-between gap-4 rounded py-4'>

                        <div className='mb-2'>
                            <div className='font-w500 fs-4'>Estimated Amount</div>
                            <label className='font-w500 fs-4 px-2 py-2 rounded' style={{ background: '#d4fb89' }}>
                                ₹ {Number(purchase.estimate_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </label>
                        </div>

                        <div className='mb-2'>
                            <div className='font-w500 fs-4'>Actual Amount</div>
                            <label className='font-w500 fs-4 px-2 py-2 rounded' style={{ background: '#d4fb89' }}>
                                ₹ {Number(purchase.actual_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </label>
                        </div>

                        <div className='mb-2'>
                            <div className='font-w500 fs-4'>Discount ({purchase.discount} %)</div>
                            <label className='font-w500 fs-4 px-2 py-2 rounded' style={{ background: '#d4fb89' }}>
                                ₹ {Number(purchase.discount_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </label>
                        </div>

                        <div className='mb-2'>
                            <div className='font-w500 fs-4'>GST ({purchase.gst} %)</div>
                            <label className='font-w500 fs-4 px-2 py-2 rounded' style={{ background: '#d4fb89' }}>
                                ₹ {Number(purchase.gst_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </label>
                        </div>

                        <div className='mb-2'>
                            <div className='text-danger font-w500 fs-4'>Total Amount</div>
                            <label className='text-danger font-w500 fs-4 px-2 py-2 rounded' style={{ background: '#d4fb89' }}>
                                ₹ {Number(purchase.total_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </label>
                        </div>

                    </div>

                </div>
            )}
        </>
    );
};

export default ViewPurchase;
